<template>
    <v-group
            @mouseover="hover(true)"
            @mouseout="hover(false)"
            @dblclick="openEditPopup"
    >
        <v-line
                :config="lineConfig"
        ></v-line>

        <LineSize v-if="!lineLengthIsHidden"
                  :fromPoint="fromPoint"
                  :toPoint="toPoint"
                  :color="color"
                  :sizeFlip="sizeFlip"
        ></LineSize>
    </v-group>
</template>

<script>
    import { mapActions } from 'vuex';
    import LineSize from "../LineSize";

    export default {
        name: "LineWithRibsPart",

        components: {
            LineSize
        },

        props: [
            'id',
            'type',
            'fromPoint',
            'toPoint',
            'lineLengthIsHidden',
            'baseLine',
            'lineColor',
            'lineColorHover',
            'sizeFlip',
        ],

        data() {
            return {
                isHovered: false,
            }
        },

        computed: {
            color() {
                return this.isHovered ? this.lineColorHover : this.lineColor;
            },

            lineConfig() {
                let xFrom = this.fromPoint.x;
                let yFrom = this.fromPoint.y;
                let xTo = this.toPoint.x;
                let yTo = this.toPoint.y;

                let points = [xFrom, yFrom, xTo, yTo];

                return {
                    name: this.type,
                    points,
                    stroke: this.color,
                    strokeWidth: 3,
                    hitStrokeWidth: 5,
                    lineCap: 'round',
                    lineJoin: 'round',
                }
            },

        },

        methods: {
            ...mapActions('editPopup', [
                'openLineWithRibsEditPopup',
            ]),

            openEditPopup() {
                let lineData = {
                    baseLine: this.baseLine,
                    type: this.type,
                    fromPoint: this.fromPoint,
                    toPoint: this.toPoint,
                };

                this.openLineWithRibsEditPopup(lineData);
            },

            hover(state) {
                this.isHovered = !!state;
            },

        },

    }
</script>

<style scoped>

</style>